<template>
  <div class="eval-area">
    <div class="eval-info" style="text-align: left; line-height: 30px;">
      <p>
        感谢您使用七喜出国说明会报名系统！<br>
        报名完成后，我们会于<b style="font-weight: 600">会议开始前7日内添加您的微信，并以微信及短信方式通知</b>您具体的时间、地点信息，希望您能够认真填写。<br>
        我们期待您的回复，并期待与您相见！
      </p>
      <p>
        <br><strong>说明会最新通知（2024年3月更新）</strong><br>
        &nbsp;&nbsp;&nbsp;&nbsp;七喜出国将于2024年上半年于以下城市举办移民说明会。<br>
      </p>
      <ul style="padding-left: 40px">
        <li>上海（3月16日 周六 下午）</li>
        <li>北京（3月23日 周六 下午）</li>
        <li>深圳（3月30日 周六 下午）</li>
        <li>成都（4月13日 周六 下午）</li>
      </ul>

    </div>
    <div class="eval-form-area">
      <el-form ref="mainForm" :rules="mainFormValidateRule" :model="form" label-width="110px"
               label-position="right">
        <div class="form-area-section">
          <el-form-item label="姓名" prop="name">
            <el-input placeholder="请输入姓名" v-model="form.name"/>
          </el-form-item>
          <el-form-item label="电话" prop="mobile">
            <el-input placeholder="请输入电话" v-model="form.mobile"/>
          </el-form-item>
          <el-form-item label="微信" prop="email">
            <el-input placeholder="请输入微信号码" v-model="form.email"/>
          </el-form-item>
          <el-form-item label="参加城市" prop="city">
            <el-select v-model="form.city" placeholder="参加城市">
              <el-option
                  v-for="(item,idx) in cities" :key="idx"
                  :label="item"
                  :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="感兴趣的项目" prop="interest">
            <el-checkbox-group v-model="form.interest">
              <el-checkbox v-for="(item,idx) in prefs" :key="idx" :value="item" :label="item" name="interest"/>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="参与人数" prop="attendNum">
            <el-input-number v-model="form.attendNum" :min="1" :max="10" label="参与人数"/>
          </el-form-item>
          <el-form-item label="你的问题">
            <el-input placeholder="请输入问题" type="textarea"
                      :rows="5" v-model="form.question"/>
          </el-form-item>

        </div>
        <div class="form-area-section">
          <div style="text-align: center">
            <el-button type="primary" @click="submit">提交报名申请</el-button>
          </div>
        </div>
      </el-form>
    </div>

  </div>

</template>

<script>
import axios from 'axios';

export default {
  name: "home",
  created() {
    axios.get('/api/informationsession/cities').then(res => {
      if (res.status === 200 && res.data.status === 0) {
        this.cities = res.data.data.cities;
      } else {
        this.$alert('服务器繁忙，请稍后再试', '提交失败', {
          confirmButtonText: '确定',
        });
      }
    }).catch(() => {
      this.$alert('服务器繁忙，请稍后再试', '提交失败', {
        confirmButtonText: '确定',
      });
    })

    axios.get('/api/informationsession/project-preferences').then(res => {
      if (res.status === 200 && res.data.status === 0) {
        this.prefs = res.data.data.prefs;
      } else {
        this.$alert('服务器繁忙，请稍后再试', '提交失败', {
          confirmButtonText: '确定',
        });
      }
    }).catch(() => {
      this.$alert('服务器繁忙，请稍后再试', '提交失败', {
        confirmButtonText: '确定',
      });
    })
  },
  data() {
    return {
      mainFormValidateRule: {
        name: [
          {required: true, message: '请输入姓名', trigger: 'blur'}
        ],
        mobile: [
          {required: true, message: '请输入正确的手机号码', trigger: 'blur', pattern: /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/},
        ],
        email: [
          {required: true, message: '请输入微信号码', trigger: 'blur'}
        ],
        city: [
          {required: true, message: '请选择参加城市', trigger: 'change'}
        ],
        interest: [
          {type: 'array', required: true, message: '请至少选择一个感兴趣的项目', trigger: 'change'}
        ],
      },
      form: {
        batchNum: 1,
        interest: [],
        attendNum: 1
      },
      cities: [],
      prefs: [],
    }
  },

  methods: {
    submit() {
      let _self = this;
      this.$refs.mainForm.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '提交中',
            spinner: 'el-icon-loading',
            background: 'rgba(255, 255, 255, 0.7)'
          });

          axios.post('/api/informationsession/new', this.form, {
            headers: {'Content-Type': 'application/json'},
          }).then(res => {
            if (res.status === 200 && res.data.status === 0) {
              this.form = {
                eduInfo: [],
                workInfo: [],
                spouse: {},
                travelInfo: {}
              }
              loading.close();
              this.$alert('您已报名成功！\n' +
                  '我们会于会议开始前7日内添加您的微信，并以微信及短信方式通知，期待您的回复，感谢您的耐心等待。', '提交成功', {
                confirmButtonText: '确定',
                callback: action => {
                  window.location.href = 'https://www.qixichuguo.com/'
                }
              });
            } else if (res.data.status === 1101) {
              loading.close();
              this.$alert('系统显示您已报名本次宣讲会，请耐心等待我们的日程结果', '提交成功', {
                confirmButtonText: '确定',
                callback: action => {
                  window.location.href = 'https://www.qixichuguo.com/'
                }
              });
            } else {
              loading.close();
              this.$alert('服务器繁忙，请稍后再试', '提交失败', {
                confirmButtonText: '确定',
              });
            }
          }).catch((err) => {
            loading.close();
          })
        } else {
          this.$message({
            type: 'info',
            message: '请您完善必填项后提交评估'
          });
        }
      });
    }
  }
}
</script>

<style scoped>
.eval-area {
  padding: 20px;
  background-color: #fff;
  width: 850px;
  border-radius: 8px;
  border: 1px solid #ccc;
  overflow-scrolling: auto;
  overflow-y: scroll;
}

.eval-info {
  font-size: 14px;
  padding: 20px 20px 40px;
  text-align: center;
  color: #333;

}

.form-area-section {
  padding-top: 10px;
}

.line {
  text-align: center;
}

.el-table__expanded-cell[class*=cell] {
  padding: 20px !important;
}

.el-checkbox-group .el-checkbox {
  width: 160px;
}

.el-checkbox-group .el-checkbox + .el-checkbox {
  margin-left: 0 !important;
}

@media screen and (min-width: 960px) {
  .eval-area {
    height: 900px;
  }
  .el-message-box {
    width: 90% !important;
  }
}

@media (max-width: 967px) {
  .eval-area {
    width: 100%;
    /*height: 1800px;*/
  }

  .eval-info {
    padding: 10px;
    text-align: left;
  }

  .el-message-box {
    width: 90% !important;
  }
}
</style>

<style>
@media screen and (min-width: 960px) {
  .eval-area {
    height: 900px;
  }
}

@media (max-width: 967px) {
  .eval-area {
    width: 100%;
    /*height: 1800px;*/
  }

  .eval-info {
    padding: 10px;
    text-align: left;
  }

  .el-message-box {
    width: 90% !important;
  }
}

</style>
